import type { LoginHistoryEntry, UserProfile } from '@/libs/interfaces'

import { MOCK_USER_ID, mockEmployees, mockUser } from './seed'

const primaryEmployee = mockEmployees[0]

export const mockUserProfile: UserProfile = {
  userID: MOCK_USER_ID,
  firstName: mockUser.firstName,
  lastName: mockUser.lastName,
  email: mockUser.email,
  phone: '+46 70 100 0001',
  address: 'Kungsgatan 12',
  city: 'Stockholm',
  state: 'Stockholm',
  zip: '111 22',
  company: primaryEmployee?.employeeComment ?? 'Care of Cars Demo',
  avatar: undefined,
}

export const mockLoginHistory: LoginHistoryEntry[] = [
  {
    loginID: 'login-1',
    userID: MOCK_USER_ID,
    time: '2026-06-30T07:55:00Z',
    IPAddress: '81.232.10.14',
  },
  {
    loginID: 'login-2',
    userID: MOCK_USER_ID,
    time: '2026-06-29T08:02:00Z',
    IPAddress: '81.232.10.14',
  },
  {
    loginID: 'login-3',
    userID: MOCK_USER_ID,
    time: '2026-06-26T07:48:00Z',
    IPAddress: '90.224.55.3',
  },
]
